import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import AndroidIntroSection from '../layouts/AndroidIntro/AndroidIntroSection'
import AndroidProcessSection from '../layouts/AndroidIntro/AndroidProcessSection'
import AndroidFeaturesSection from '../layouts/AndroidIntro/AndroidFeaturesSection'
import FinalCTA from '../layouts/FinalCTA'

const AndroidApps = () => {
  return (
    <>
    <Header/>
    <AndroidIntroSection/>
    <AndroidProcessSection/>
    <AndroidFeaturesSection/>
    <FinalCTA/>
    <Footer/>
    </>
  )
}

export default AndroidApps